import ActivityContextProvider from "PFApp/activities/show/activity_context_provider";
import ActivityPageLegacy from "PFApp/activities/show/activity_page";
import useStorage from "PFCore/helpers/use_storage";
import React from "react";
import { useParams } from "react-router-dom";

import { ActivityPage } from "./activity_page_v2/activity_page";

const ActivityShowController = () => {
  const { id } = useParams();
  const [isNewLayout] = useStorage("new_activity_page", false);

  return (
    <ActivityContextProvider id={id}>
      {isNewLayout ? <ActivityPage /> : <ActivityPageLegacy />}
    </ActivityContextProvider>
  );
};

export default ActivityShowController;
